import styled from 'styled-components';
import { SummaryPlayEventsWrapper, IconWrapper } from '../Play/play/SummaryPlayEvents.style';
import { BaseVoteLink } from '../PlayerOfTheGame/PlayerOfTheGame.style';
import { Label } from '@mlb/react-patterns/v4/components/Button/button.style';
import { IconWrapper as IconWrapperPatterns } from '@mlb/react-patterns/v4/components/Icon/icon.style';
import ModalContent from '@mlb/react-patterns/v4/components/Modal/ModalContent/modalContent';
import Button from '@mlb/react-patterns/v4/components/Button/button';
import ModalWithAnimation from '@mlb/react-patterns/v4/components/ModalWithAnimation/modalWithAnimation';

export const CloseButton = styled(Button)`
    padding: 0;
    align-self: end;
    height: 24px;
`;

export const FeedWrapper = styled(SummaryPlayEventsWrapper)`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-summary-play-event-color);
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    position: relative;
    padding-left:0;

    ${IconWrapper} {
        width: 48px;
        height: 48px;
        left: -55px;
    }
`;

export const TitleWrapper = styled.div`
    font-size: 14px;
    font-weight: 700;
`;

export const DescWrapper = styled.div`
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: var(--gameday-primary-font-color);

    a {
        color: var(--gameday-primary-font-color);
        &:hover {
            color: var(--gameday-audio-list-link-hover-color);
        }
    }
`;

export const PromoModal = styled(ModalWithAnimation)`
    position: static;
`;

export const CustomModalContent = styled(ModalContent)`
    background-color: var(--gameday-toast-background-color);
    border-top: 1px solid var(--gameday-toast-border-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--gameday-section-padding-sm);
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);
    box-sizing: border-box;
    ${({ styleName }) => styleName === 'full' && 'left: 0;'}
    width: ${({ styleName }) => styleName !== 'full' ? '375px' : '100%'};
    border-radius: ${({ styleName }) => styleName !== 'full' ? '0 0 var(--gameday-border-radius) var(--gameday-border-radius)' : '0'};
    padding: ${({ styleName }) => styleName !== 'full' ? 'var(--gameday-section-padding-sm)' : 'var(--gameday-section-padding-sm) var(--gameday-section-padding-sm) 40px'};
    position: ${({ styleName }) => styleName !== 'full' ? 'static' : 'fixed'};

    ${CloseButton} {
        margin-right: 0px;
    }

    ${BaseVoteLink} {
        display: inline-flex;
        font-size: 14px;
        height: 45px;
        border: 1px solid var(--gameday-primary-font-color);
        border-radius: 40px;
        font-weight: 700;

        ${Label} {
            color: var(--gameday-primary-font-color);
            margin-right: 8px;
        }
        ${IconWrapperPatterns} {
            width: 12px;
            height: 12px;
            padding-top: unset;
            fill: var(--gameday-primary-font-color);
            path {
                fill: var(--gameday-primary-font-color);
            }
        }
        &:hover {
            background: none;
            ${Label} {
                color: var(--gameday-primary-font-color);
            }
            ${IconWrapperPatterns} {
                fill: var(--gameday-primary-font-color);
                path {
                    fill: var(--gameday-primary-font-color);
                }
            }
        }
    }
`;

export const ToastTitleWrapper = styled.div`
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
`;

export const ToastsMessageWrapper = styled.div`
        position: ${({ styleName, isSticky }) => styleName !== 'full' ? `${!isSticky ? 'fixed' : 'sticky'}` : 'relative'};
        width: 100%;
        bottom: 0;
        z-index: 999999;
`;
